<template>
    <div class="select_wrap">
        <van-dropdown-menu>
            <van-dropdown-item v-model="value" :options="options" :title="title" @change="changeSelect">

            </van-dropdown-item>
        </van-dropdown-menu>
    </div>
</template>

<script>
    export default {
        name: 'vant-select',
        //list:数据（对象，数组，对象数组）
        //optionName:对象数组中用到，展示文字的字段名称
        //type：判断数据类型（对象，数组，对象数组）
        //default：默认展示文字（该字段有值展示该字段文字，没有展示"请选择"）
        //showTitle：如果是no，选择完以后不切换展示文字，永远显示default
        //defaultValue：默认选中哪个选项
        props: ['list','optionName','type','default','showTitle','defaultValue'],
        components: {},
        data() {
            return {
                isSwitchOrg:this.default=="切换组织",
                title:this.default ? this.default : "请选择",
                value:this.defaultValue ? parseInt(this.defaultValue) : '',
                options:[],
            }
        },
        computed: {

        },
        created() {
            console.log(this.value)
            var self = this

            if (self.type == 'object') {
                Object.keys(self.list).forEach(function(key,index){
                    self.options.push({text:self.list[key],value:index+1,item:key})
                });

            }
            if (self.type == 'baseArr') {
                self.list.forEach(function(item,index){
                    self.options.push({text:item,value:index+1,item:item})
                })

            }
            if (self.type == 'objectArr') {
                self.list.forEach(function(item,index){
                    if(self.isSwitchOrg){
                        var name=item[self.optionName]
                        if(item.isLeagueAdmin==1){
                            name+="(管理员)"

                        }else if(item.isObserver==1) {
                            name+="(观察员)"

                        }
                        if(item.isDefaultLeague==1){
                            name+="默认组织"
                        }


                            self.options.push({text:name,value:index+1,item:item})


                    }else {
                        self.options.push({text:item[self.optionName],value:index+1,item:item})

                    }

                })
            }
        },
        mounted() {
        },
        beforeDestroy() {
        },
        methods: {
            changeSelect(index){
                this.title = this.showTitle == 'no' ? this.default : this.options[index-1].text+''
                this.$emit('chooseFn', this.options[index-1].item)
            }

        }
    }
</script>

<style scoped>
    /deep/ .van-dropdown-menu__bar{
        height: 100%;
        box-shadow: none;
    }
    /deep/ .van-dropdown-item__content{
        max-height: 200px;
        overflow-y: scroll;
    }

    /*/deep/ .van-dropdown-item__content{*/
    /*    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);*/
    /*}*/


</style>
